import { InjectionToken } from '@angular/core';

import type { OrderDetailsBlockScenarioContent } from '@front-platform/content-builder';
import { DoodOrderModel } from '@store/order/order.model';

/** Runtime VM emitted by `OrderDetailsBlock` data sources. */
export type OrderDetailsBlockViewModel = {
  order: DoodOrderModel | null;
  onSiteLocationName: string;
};

/** Scenario transport matches the runtime VM shape (order cast at the preview boundary). */
export type OrderDetailsBlockScenarioViewModel = OrderDetailsBlockScenarioContent;

export const ORDER_DETAILS_BLOCK_LOADING_VM: OrderDetailsBlockViewModel = {
  order: null,
  onSiteLocationName: '',
};

export interface OrderDetailsBlockDataSource {
  readonly vm$: import('rxjs').Observable<OrderDetailsBlockViewModel>;
}

export const ORDER_DETAILS_BLOCK_DATA_SOURCE = new InjectionToken<OrderDetailsBlockDataSource>(
  'ORDER_DETAILS_BLOCK_DATA_SOURCE',
);
